import React from 'react';
import { useAuthStore } from '../auth/store';
import InfoBar from '../navigation/components/InfoBar';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react-native';
import { Platform } from 'react-native';

/**
 * ImpersonationBar component that:
 * 1. Monitors impersonation status from the auth store
 * 2. Shows a warning InfoBar when impersonation is active
 * 3. Provides a logout button to end the impersonated session
 */
const ImpersonationBar = () => {
  const { t } = useTranslation();
  const { impersonatedBy, user, logout } = useAuthStore((state) => ({
    impersonatedBy: state.impersonatedBy,
    user: state.user,
    logout: state.logout
  }));

  if (!impersonatedBy) return null;

  const handleStopImpersonation = async () => {
    await logout();
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      window.close();
    }
  };

  return (
    <InfoBar
      message={t('admin.impersonation_active', {
        user: `${user?.firstname} ${user?.lastname}`
      }) || `You are currently impersonating ${user?.firstname} ${user?.lastname}`}
      level="info"
      buttonIcon={X}
      onButtonPress={handleStopImpersonation}
      allowDismiss={false}
    />
  );
};

export default ImpersonationBar;

